import { State } from '../../../types/state';

export const currentAnnotationQueueSelector = (state: State) =>
  // Optional chaining just for reducer tests
  state.annotation.sideloads?.queue;
